const productionApi = "https://drugmart-tsx-server.herokuapp.com/api/v1";
const renderApi = "https://server.easymeds.ng/api/v1";
const devApi = "/api/v1";

export const api = renderApi; // Change this to productionApi or devApi as needed
//kkk
